export default "__VITE_ASSET__BWcBdqC3__"